module.exports = __webpack_public_path__ + "static/media/princess.e4fb3b10.jpg";